module.exports = __webpack_public_path__ + "static/media/8.c5c09750.JPG";